/**
 *                                          __  __
 *    ____  ______      ______ _      __   / /_/ /_  ___  ____ ___  ___
 *   / __ \/ ___/ | /| / / __ \ | /| / /  / __/ __ \/ _ \/ __ `__ \/ _ \
 *  / / / (__  )| |/ |/ / /_/ / |/ |/ /  / /_/ / / /  __/ / / / / /  __/
 * /_/ /_/____/ |__/|__/\____/|__/|__/   \__/_/ /_/\___/_/ /_/ /_/\___/
 *
 * ns.wow WordPress theme
 * by Neidhart + Schön Group
 */


import Accordion from './Accordion';
import XDownloader from "./XDownloader";
// import AnchorScroll from "./AnchorScroll";

var downloaderInstance = null;
var anchorContainerInstance = null;

var accordionToggleInstance = null;

export default {

  version: () => {
    return NSContext.theme.version;
  },
};

// Initialize on document ready

document.addEventListener("DOMContentLoaded", function () {

  new Accordion({
    accordions: '.js-toggle-accordion'
  });

  // anchorContainerInstance = new AnchorScroll({
  //   containerSelector: '.ns-anchor'
  // });


  downloaderInstance = new XDownloader({
    tableTitle: 'Zueblin',
    tableSelector: '.ns-table-wrap',
    downloadText: " ", //Can be empty if you want to use an icon instead
    mergeStrings: [],
    numFmt: (cell, cellIndex, rowIndex) => {
      if ((String(cell.value).replace(' ', '')).trim().match(/^[+-]?(\d*\.\d+|\d+\.\d*|\d+)$/)) {
        cell.value = parseFloat(String(cell.value).trim().replace(' ', ''));
        cell.numFmt = '#,##0';
        /*console.log(cell._address, cell.value)*/
      }
    },
    styles: [
      {
        class: 'noline_head ',
        font: {
          bold: true,
          color: {
            argb: 'FF000000'
          }
        },
        head: true,
        index: 10
      },
      {
        class: 'noline_bold',
        font: {
          bold: true
        },
        border: {
          bottom: {
            style: 'bold',
            color: {
              argb: 'FF000000'
            }
          },
        },
      }
    ]
  });
});


